export const getApiUrl = (endpoint: string): string => {
  const cleanEndpoint = endpoint.replace(/^\//, '');
  return `${window.location.origin}/${cleanEndpoint}`;
  // подмена url для прокси
  // return `/${cleanEndpoint}`;
};
